import { FeatureFlags, FeatureFlagsActionType, SET_FEATURE_FLAGS } from './types';

export const setFeatureFlags = (featureFlags: FeatureFlags = {}): FeatureFlagsActionType => {
	return {
		type: SET_FEATURE_FLAGS,
		payload: featureFlags,
	};
};
